export const PostType = Object.freeze({
    Tutorial: 'Tutorial',
    CaseReport: 'CaseReport',
})
